import { Post } from "@/wp/types/client.ts";
import styles from "./TeamPostList.module.scss";
import { Section } from "@/components/Section/Section.tsx";
import { CustomLink } from "@/components/CustomLink.tsx";
import { customSanitize } from "@/utils/customSanitize.ts";
import { Headline } from "@/components/Headline/Headline.tsx";
import { useGlobalContext } from "@aleksundshantu/aunds-utils-react/contexts";

type TeamPostListProps = {
  posts: Post<"blog">[];
};

export const TeamPostList = ({ posts }: TeamPostListProps) => {
  const { getLabel } = useGlobalContext();

  if (!posts.length) return null;

  return (
    <Section disableColumns className={styles["team-post-list-wrapper"]}>
      <Headline
        headline_html_tag={"h2"}
        headline={getLabel("headline_article_of_author", "Artikel des Autoren")}
      />
      <ul className={styles["team-post-list"]}>
        {posts.map((post) => (
          <li key={post.id} className={styles["team-post-list-item"]}>
            <CustomLink target={"_self"} href={post.link}>
              {customSanitize(post.acf.header_post.title)}
            </CustomLink>
          </li>
        ))}
      </ul>
    </Section>
  );
};
